module.exports = __webpack_public_path__ + "Body_feathers_Normal.4329f71.basis";